module.exports = __webpack_public_path__ + "img/infi_folder.8629df8e.png";